import React from 'react';
import Fade from 'react-reveal/Fade';
import { useStaticQuery, graphql } from 'gatsby';
import { Icon } from 'react-icons-kit';
import { playCircle } from 'react-icons-kit/fa/playCircle';
import Text from 'common/components/Text';
import Image from 'common/components/Image';
import Button from 'common/components/Button';
import Heading from 'common/components/Heading';
import Rating from 'common/components/Rating';
import Container from 'common/components/UI/Container';
import GatsbyImage from 'common/components/GatsbyImage';
import BannerWrapper, {
  BannerContent,
  RatingInfo,
  BannerImage,
  ButtonGroup,
} from './banner.style';

import microsoft from 'common/assets/image/appClassic/microsoft.svg';

const Banner = () => {
  const Data = useStaticQuery(graphql`
    query {
      appScreenshot: file(
        relativePath: { eq: "image/appClassic/bannerImg.png" }
      ) {
        childImageSharp {
          gatsbyImageData(
            width: 459
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
    }
  `);
  return (
    <BannerWrapper id="home">
      <Container>
        <BannerContent>
          <Fade up>
            <RatingInfo>
              <Rating rating={4} />
              4.9 of 5 By Customers
            </RatingInfo>
          </Fade>
          <Fade up delay={100}>
            <Heading
              as="h1"
              content="Revolutionize Trade Finance with AI"
            />
          </Fade>
          <Fade up delay={200}>
            <Text content="Global Trade Finance valued at $25 trillion, Korenext provides an innovative AI platform to digitise trade documents and automate the trade finance operation for banks, exporters and importers." />
            <Text content="Designed by Trade Expert, we simplify trade finance using innovation to remove automate laborious manual processes and deliver unrivalled quality and accuracy. Cutting the traditionally laborious 50-year process of verifying Letters of Credit and Collection documents sets from 5 days to 2 hours empowered by Large Language Model, boosting import-export operations, 
liquidity, working capital optimization." />
          </Fade>
          {/* <Fade up delay={300}>
            <ButtonGroup>
              <Button className="primary" title="Start Free trail" />
              <Button
                className="text"
                variant="textButton"
                icon={<Icon icon={playCircle} />}
                iconPosition="left"
                title="Watch Video"
              />
            </ButtonGroup>
          </Fade> */}
        </BannerContent>
        <BannerImage>
          <Fade up delay={100}>
            <GatsbyImage
              src={
                (Data.appScreenshot !== null) | undefined
                  ? Data.appScreenshot.childImageSharp.gatsbyImageData
                  : {}
              }
              alt="App Screenshot"
            />
          </Fade>
        </BannerImage>
      </Container>
    </BannerWrapper>
  );
};

export default Banner;
